var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWithBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2507 11.2405V11.9905C11.6649 11.9905 12.0007 11.6547 12.0007 11.2405H11.2507ZM11.2507 12.7405H12.0007C12.0007 12.3263 11.6649 11.9905 11.2507 11.9905V12.7405ZM12.7507 12.7405V11.9905C12.3364 11.9905 12.0007 12.3263 12.0007 12.7405H12.7507ZM12.7507 11.2405H12.0007C12.0007 11.6547 12.3364 11.9905 12.7507 11.9905V11.2405ZM12.0007 8.32733H13.5007C13.5007 7.4989 12.8291 6.82733 12.0007 6.82733V8.32733ZM12.0007 8.32733H12.0007V6.82733C11.1722 6.82733 10.5007 7.4989 10.5007 8.32733H12.0007ZM12.0007 11.2405V8.32733H10.5007V11.2405H12.0007ZM8.33398 11.9905H11.2507V10.4905H8.33398V11.9905ZM8.33398 11.9905V10.4905C7.50556 10.4905 6.83398 11.1621 6.83398 11.9905H8.33398ZM8.33398 11.9905H6.83398C6.83398 12.8189 7.50556 13.4905 8.33398 13.4905V11.9905ZM11.2507 11.9905H8.33398V13.4905H11.2507V11.9905ZM12.0007 15.6537V12.7405H10.5007V15.6537H12.0007ZM12.0007 15.6537H12.0007H10.5007C10.5007 16.4821 11.1722 17.1537 12.0007 17.1537V15.6537ZM12.0007 15.6537V17.1537C12.8291 17.1537 13.5007 16.4821 13.5007 15.6537H12.0007ZM12.0007 12.7405V15.6537H13.5007V12.7405H12.0007ZM15.6673 11.9905H12.7507V13.4905H15.6673V11.9905ZM15.6673 11.9905V13.4905C16.4957 13.4905 17.1673 12.8189 17.1673 11.9905H15.6673ZM15.6673 11.9905H17.1673C17.1673 11.1621 16.4957 10.4905 15.6673 10.4905V11.9905ZM12.7507 11.9905H15.6673V10.4905H12.7507V11.9905ZM12.0007 8.32733V11.2405H13.5007V8.32733H12.0007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWithBox);
export default __webpack_public_path__ + "static/media/plus_with_box.902a2c50f2d44a51abd0dd58c391af10.svg";
export { ForwardRef as ReactComponent };